
import React from "react";

export const TickIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-[14px] h-[14px] text-white",
    ...props
}) => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" className={className} {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M11.8049 2.86225C12.0652 3.1226 12.0652 3.54471 11.8049 3.80506L5.8049 9.80506C5.54455 10.0654 5.12244 10.0654 4.86209 9.80506L1.52876 6.47173C1.26841 6.21138 1.26841 5.78927 1.52876 5.52892C1.78911 5.26857 2.21122 5.26857 2.47157 5.52892L5.3335 8.39085L10.8621 2.86225C11.1224 2.6019 11.5446 2.6019 11.8049 2.86225Z" fill="currentColor" />
        </svg>

    );
};



